(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pawcare-header]').forEach((header) => {
    if (header.dataset.ready === 'true') return;
    header.dataset.ready = 'true';

    const runTransition = (callback) => {
      if (document.startViewTransition) {
        document.startViewTransition(callback);
      } else {
        callback();
      }
    };

    const searchDialog = header.querySelector('[data-search-dialog]');
    const searchOpen = header.querySelector('[data-search-open]');
    const searchClose = header.querySelector('[data-search-close]');

    if (searchDialog && searchOpen && searchClose) {
      searchOpen.addEventListener('click', () => {
        runTransition(() => searchDialog.showModal());
        window.setTimeout(() => searchDialog.querySelector('input[type="search"]')?.focus(), 80);
      });

      searchClose.addEventListener('click', () => runTransition(() => searchDialog.close()));
      searchDialog.addEventListener('click', (event) => {
        if (event.target === searchDialog) runTransition(() => searchDialog.close());
      });
    }

    const mobileMenu = header.querySelector('[data-mobile-menu]');
    if (mobileMenu) {
      mobileMenu.addEventListener('toggle', () => {
        document.documentElement.classList.toggle('pc-menu-open', mobileMenu.open);
      });

      mobileMenu.querySelectorAll('[data-mobile-close]').forEach((button) => {
        button.addEventListener('click', () => {
          runTransition(() => {
            mobileMenu.open = false;
          });
        });
      });
    }

    header.querySelectorAll('.pc-desktop-item').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        header.querySelectorAll('.pc-desktop-item').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pawcare-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pc-header]').forEach((header) => {
    if (header.dataset.pcReady === 'true') return;
    header.dataset.pcReady = 'true';

    const megaToggle = header.querySelector('[data-pc-mega-toggle]');
    const mega = header.querySelector('[data-pc-mega]');

    const setMega = (open) => {
      if (!mega || !megaToggle) return;
      mega.hidden = !open;
      megaToggle.setAttribute('aria-expanded', String(open));
    };

    megaToggle?.addEventListener('click', () => {
      setMega(megaToggle.getAttribute('aria-expanded') !== 'true');
    });

    document.addEventListener('click', (event) => {
      if (mega?.hidden || header.contains(event.target)) return;
      setMega(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (mega && !mega.hidden) {
        setMega(false);
        megaToggle?.focus();
      }
    });

    const mobileDialog = header.querySelector('[data-pc-mobile-dialog]');
    const mobileOpen = header.querySelector('[data-pc-mobile-open]');

    mobileOpen?.addEventListener('click', () => {
      if (!mobileDialog?.open) {
        mobileDialog?.showModal();
        mobileDialog?.focus({ preventScroll: true });
      }
      document.documentElement.classList.add('pc-o1-menu-open');
    });

    header.querySelectorAll('[data-pc-mobile-close]').forEach((button) => {
      button.addEventListener('click', () => mobileDialog?.close());
    });

    mobileDialog?.addEventListener('close', () => {
      document.documentElement.classList.remove('pc-o1-menu-open');
      mobileOpen?.focus();
    });

    mobileDialog?.addEventListener('click', (event) => {
      if (event.target === mobileDialog) mobileDialog.close();
    });

    mobileDialog?.querySelectorAll('[data-pc-mobile-guide]').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        mobileDialog.querySelectorAll('[data-pc-mobile-guide]').forEach((other) => {
          if (other !== group) other.open = false;
        });
      });
    });

    const searchDialog = header.querySelector('[data-pc-search-dialog]');
    const searchOpeners = header.querySelectorAll('[data-pc-search-open]');
    const searchClose = header.querySelector('[data-pc-search-close]');

    searchOpeners.forEach((button) => {
      button.addEventListener('click', () => {
        if (mobileDialog?.open) mobileDialog.close();
        if (!searchDialog?.open) searchDialog?.showModal();
        window.setTimeout(() => searchDialog?.querySelector('input[type="search"]')?.focus(), 60);
      });
    });

    searchClose?.addEventListener('click', () => searchDialog?.close());
    searchDialog?.addEventListener('click', (event) => {
      if (event.target === searchDialog) searchDialog.close();
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 899 && mobileDialog?.open) mobileDialog.close();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
